// @ts-nocheck
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';
import { RangePicker } from '../../../components/ui';
import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../components';
import Field from './../../../components/card/Field';
import { formatDateTimeToISOString } from './../../../lib/helpers';
const {
  CompanySelect
} = Selects;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-od8zv0-0"
})(["padding:16px;"]);
export const ContractFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => <SpoilerContent>
    <FilterContainer>
      <Filter cleanFilter={cleanFilter} applyFilter={applyFilter} initialValues={filter}>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) => <>
            {/* <FilterItem>
              <Field mBottomNone>
                <Input
                  size="small"
                  placeholder="Номер ТС"
                  onChange={(e) => changeValue('search', e.target.value)}
                  value={values.search}
                />
              </Field>
             </FilterItem> */}
            <FilterItem>
              <Field mBottomNone>
                <CompanySelect size="small" onChange={value => changeValue('companyId', value)} value={values.companyId} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker size="small" startDate={values.startDate ? moment.utc(values.startDate) : null} endDate={values.endDate ? moment.utc(values.endDate) : null} onChange={changeValue} />
              </Field>
            </FilterItem>

            <FilterButtonsContainer applyFilter={applyFilter} cleanFilter={cleanFilter} />
          </>}
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
export default ContractFilter;
